import { useTranslation } from 'i18n';
import { Link } from 'react-router-dom';
import { Alert, AlertTitle, DataCard } from 'ui';
import { Insights } from 'ui/icons';

type Props = {
  isLoading?: boolean;
  sessionLink?: string;
  sessionName?: string;
};

export const MaterialNotAnalysedDataCard = ({ isLoading, sessionLink, sessionName }: Props) => {
  const { t } = useTranslation('features');

  return (
    <DataCard
      dataTestId="material-not-analysed"
      isLoading={isLoading}
      slotProps={{
        header: {
          avatar: <Insights />,
          title: t('dataCards.materialNotAnalysed.analysisTitle'),
        },
      }}
    >
      {sessionLink && sessionName ? (
        <DataCard.Item title={t('dataCards.materialNotAnalysed.reportTitle')} colSpan={6}>
          <Link to={sessionLink}>{sessionName}</Link>
        </DataCard.Item>
      ) : null}
      <DataCard.Item colSpan={12}>
        <Alert severity="info" data-testid="no-analysis-alert">
          <AlertTitle>{t('dataCards.materialNotAnalysed.noResultsTitle')}</AlertTitle>
          {t('dataCards.materialNotAnalysed.noResultsDescription')}
        </Alert>
      </DataCard.Item>
    </DataCard>
  );
};
